import { FormSeparator } from '../../components/FormSeparator';

type FormContainerProps = {
  left?: React.ReactNode;
  actions?: React.ReactNode;
  error?: string;
  topRight?: React.ReactNode;
};

export const FormContainer: React.FC<FormContainerProps> = ({
  actions,
  left,
  error,
  children,
  topRight,
}) => {
  return (
    <div className="mt-12 flex flex-col bg-white border-1 border-gray-200 rounded-lg p-16 relative">
      {topRight && <div className="absolute top-6 right-6">{topRight}</div>}
      <div className="flex gap-x-16">
        {left}
        <div className="flex flex-col flex-grow">{children}</div>
      </div>
      <div className="flex justify-end gap-x-6 mt-10">{actions ?? 'Actions'}</div>
      {error && error.length > 0 && (
        <span className="text-red-500 text-[12px] inline-block ml-auto">
          Please fix the errors to be able to save
        </span>
      )}
    </div>
  );
};
